export const octaDeskScript = (octaDeskToken: string) => `
(function (o, c, t, a) {
      o.octadesk = o.octadesk || {};
      o.octadesk.chatOptions = {
        subDomain: a,
        showButton: false,
        openOnMessage: false,
        showFooterPoweredBy: false,
        hide: true
      };
      var bd = c.getElementsByTagName("body")[0];
      var sc = c.createElement("script");
      sc.async = 1;
      sc.src = t;
      bd.appendChild(sc);
    })(window, document, 'https://cdn.octadesk.com/embed.js', '${octaDeskToken}');
`;
